import { useQuery } from "convex/react";
import { api } from "../../api";
import { type GenericId as Id } from "convex/values";

export const useDeviceAppRequests = (deviceId: string) => {
  const requests = useQuery(api.requests.list.appRequestsByDevice, {
    device: deviceId as Id<"devices">,
    paginationOpts: {
      cursor: null,
      numItems: 100,
    },
  });

  // Handle validation errors gracefully
  if (requests === null) {
    return {
      requests: [],
      isLoading: false,
      error: "Unable to load app requests due to data validation error",
    };
  }

  return {
    requests: requests?.page?.flat() || [],
    isLoading: requests === undefined,
    error: undefined,
  };
};

export const useDeviceWebRequests = (deviceId: string) => {
  const requests = useQuery(api.requests.list.webRequestsByDevice, {
    device: deviceId as Id<"devices">,
    paginationOpts: {
      cursor: null,
      numItems: 100,
    },
  });

  // Handle validation errors gracefully
  if (requests === null) {
    return {
      requests: [],
      isLoading: false,
      error: "Unable to load web requests due to data validation error",
    };
  }

  return {
    requests: requests?.page?.flat() || [],
    isLoading: requests === undefined,
    error: undefined,
  };
};
